import { CheckAuthorizeStatusAsync } from "../authService";
import store from "@/store";


//Dashboard stats

export async function getDashboardStatisticsAsync(){
    const url = `${process.env.VUE_APP_API_URL}Administrator/Statistics`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    

    await CheckAuthorizeStatusAsync(response);
    return response.json();

}



//For JobSeekers
export async function getJobSeekerAccountsAsync(page){
    const url = `${process.env.VUE_APP_API_URL}Administrator/Users/JobSeekers/${page}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    

    await CheckAuthorizeStatusAsync(response);
    return response.json();

}

export async function searchJobSeekerAccountsAsync(search, page){
    const url = `${process.env.VUE_APP_API_URL}Administrator/Users/Search/JobSeekers/${page}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify({search})
    });
     await CheckAuthorizeStatusAsync(response);
    return response.json();
}


//For Employers


export async function getEmployerAccountsAsync(page){
    const url = `${process.env.VUE_APP_API_URL}Administrator/Users/Employers/${page}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    

    await CheckAuthorizeStatusAsync(response);
    return response.json();

}

export async function searchEmployerAccountsAsync(search, page){
    const url = `${process.env.VUE_APP_API_URL}Administrator/Users/Search/Employers/${page}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify({search})
    });
     await CheckAuthorizeStatusAsync(response);
    return response.json();
}

export async function confirmEmailAsync(id){
    const url = `${process.env.VUE_APP_API_URL}Administrator/Users/ConfirmEmail/${id}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}

export async function toggleActivationAsync(id){
    const url = `${process.env.VUE_APP_API_URL}Administrator/Users/ToggleActivation/${id}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}

export async function toggleAuthorizationAsync(id){
    const url = `${process.env.VUE_APP_API_URL}Administrator/Users/ToggleAuthorization/${id}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}

export async function renewSubscriptionAsync(id){
    const url = `${process.env.VUE_APP_API_URL}Administrator/Users/RenewSubscription/${id}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
}